import * as angular from 'angular';
import * as _ from 'lodash';

import { IDigitalCorrespondanceTableService } from '@services/index';
import { DigitalCorrespondanceTable } from '@models/index';
import { Store } from '../Store';
import * as DIGITALCORRESPONDANCETABLES from './digitalCorrespondanceTables.constants';

import {
    loadDigitalCorrespondanceTables,
    loadDigitalCorrespondanceTablesSuccess,
    addDigitalCorrespondanceTable,
    addDigitalCorrespondanceTableSuccess,
    updateDigitalCorrespondanceTable,
    updateDigitalCorrespondanceTableSuccess,
    deleteDigitalCorrespondanceTable,
    deleteDigitalCorrespondanceTableSuccess
} from './digitalCorrespondanceTables.actions';


export interface IDigitalCorrespondanceTableActionsService {
    getOne(guid: string): (dispatch: any, getState: () => Store) => angular.IPromise<DigitalCorrespondanceTable>;
    getAll(): (dispatch: any, getState: () => Store) => angular.IPromise<DigitalCorrespondanceTable[]>;
    getAll(force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<DigitalCorrespondanceTable[]>;
    addOne(target: DigitalCorrespondanceTable): (dispatch: any, getState: () => Store) => angular.IPromise<DigitalCorrespondanceTable[]>;
    updateOne(target: DigitalCorrespondanceTable): (dispatch: any, getState: () => Store) => angular.IPromise<DigitalCorrespondanceTable[]>;
    deleteOne(guid: string): (dispatch: any, getState: () => Store) => angular.IPromise<DigitalCorrespondanceTable[]>;
}

export class DigitalCorrespondanceTablesActionsService implements IDigitalCorrespondanceTableActionsService {

    static serviceId = 'digitalCorrespondanceTableActionsService';
    static $inject = ['$q', 'digitalCorrespondanceTableService'];
    constructor(
        private _$q: angular.IQService,
        private _digitalCorrespondanceTableService: IDigitalCorrespondanceTableService) {
    }

    getOne(guid: string) {
        return (dispatch: any, getState: () => Store) => {
            const { digitalCorrespondanceTables } = getState();
            if (!digitalCorrespondanceTables.isLoading && !digitalCorrespondanceTables.isLoaded) {
                dispatch(loadDigitalCorrespondanceTables());
                return this._digitalCorrespondanceTableService.getAll(true)
                    .then(data => {
                        const result = data.filter(c => c.guid === guid);
                        dispatch(loadDigitalCorrespondanceTablesSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: DIGITALCORRESPONDANCETABLES.DIGITAL_CORRESPONDANCE_TABLES_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.find(_.values<DigitalCorrespondanceTable>(digitalCorrespondanceTables.dictionary), c => c.guid === guid));
            }
        };
    }

    getAll();
    getAll(force: boolean);
    getAll(force?: boolean) {
        return (dispatch: any, getState: () => Store) => {
            const { digitalCorrespondanceTables } = getState();
            if (force || (!digitalCorrespondanceTables.isLoading && !digitalCorrespondanceTables.isLoaded)) {
                dispatch(loadDigitalCorrespondanceTables());
                return this._digitalCorrespondanceTableService.getAll(force)
                    .then(data => {
                        dispatch(loadDigitalCorrespondanceTablesSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: DIGITALCORRESPONDANCETABLES.DIGITAL_CORRESPONDANCE_TABLES_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<DigitalCorrespondanceTable>(digitalCorrespondanceTables.dictionary));
            }
        };
    }

    addOne(target: DigitalCorrespondanceTable) {
        return (dispatch: any, getState: () => Store) => {
            const { digitalCorrespondanceTables } = getState();
            if (target) {
                dispatch(addDigitalCorrespondanceTable(target));
                return this._digitalCorrespondanceTableService.addOne(target)
                    .then(data => {
                        const result = data;
                        dispatch(addDigitalCorrespondanceTableSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: DIGITALCORRESPONDANCETABLES.DIGITAL_CORRESPONDANCE_TABLES_ADD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<DigitalCorrespondanceTable>(digitalCorrespondanceTables.dictionary));
            }
        };
    }

    updateOne(target: DigitalCorrespondanceTable) {
        return (dispatch: any, getState: () => Store) => {
            const { digitalCorrespondanceTables } = getState();
            if (target) {
                dispatch(updateDigitalCorrespondanceTable(target));
                return this._digitalCorrespondanceTableService.updateOne(target)
                    .then(data => {
                        const result = data;
                        dispatch(updateDigitalCorrespondanceTableSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: DIGITALCORRESPONDANCETABLES.DIGITAL_CORRESPONDANCE_TABLES_UPDATE_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<DigitalCorrespondanceTable>(digitalCorrespondanceTables.dictionary));
            }
        };
    }

    deleteOne(guid: string) {
        return (dispatch: any, getState: () => Store) => {
            const { digitalCorrespondanceTables } = getState();
            if (guid) {
                dispatch(deleteDigitalCorrespondanceTable(guid));
                return this._digitalCorrespondanceTableService.deleteOne(guid)
                    .then(data => {
                        const result = data;
                        dispatch(deleteDigitalCorrespondanceTableSuccess(guid));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: DIGITALCORRESPONDANCETABLES.DIGITAL_CORRESPONDANCE_TABLES_DELETE_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<DigitalCorrespondanceTable>(digitalCorrespondanceTables.dictionary));
            }
        };
    }
}